import { Dimensions } from 'components/insights/constants';
import { Breadcrumb } from 'components/shared/Breadcrumbs';
import { InsightsFilterState } from 'stores/insightsStore';

export type DrillInSnapshot = {
  filters: InsightsFilterState;
  selectedDimensions: Dimensions[];
};

export type InsightsBreadcrumb = Breadcrumb<Partial<DrillInSnapshot>> & {
  id: number;
};

export type ChartSeries = {
  categories: string[];
  series: (number | null)[][];
};

export type CategoryRow = {
  categoryName: string;
  discharges?:
    | {
        current: number | null;
        prior: number | null;
      }
    | number
    | null;
  locationEpisodes?: number | null;
  episodes?: number | null;
};

export type CategoryResponseTimeRow = {
  categoryName: string;
  responseTime: { current: number | null; prior: number | null };
  count: number | null;
};

export function alphaNumericSort(a: string, b: string) {
  // Check if strings start with digits
  const aStartsWithDigit = /^\d/.test(a);
  const bStartsWithDigit = /^\d/.test(b);

  // Numbers before letters
  if (aStartsWithDigit && !bStartsWithDigit) return -1;
  if (!aStartsWithDigit && bStartsWithDigit) return 1;

  // Both same type: use localeCompare for natural sorting
  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
}
